import { render, staticRenderFns } from "./Common.vue?vue&type=template&id=28d021ac&scoped=true"
import script from "./Common.vue?vue&type=script&lang=js"
export * from "./Common.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d021ac",
  null
  
)

export default component.exports